export type Testimonial = {
  quote: string;
  author: string;
  role: string;
  company?: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      "As General Manager for Macedonia, I need to balance strategic oversight with operational details. PharmaVision's reporting system strikes that perfect balance—giving me high-level KPIs at a glance while allowing me to dive deep into individual performance, territory coverage, and product trends when needed. The system has reduced our reporting cycle from weeks to minutes, and the accuracy has improved dramatically. I can't imagine going back to our old way of working.",
    author: 'Anica Zorik Zajkova',
    role: 'General Manager for Macedonia',
    company: 'PharmaS',
  },
  {
    quote:
      'PharmaVision transforms complex pharmaceutical sales data into clear, actionable insights. The analytics dashboard gives me everything I need—earnings trends, product coverage, target achievement, and market penetration—visualized through intuitive charts. I can quickly filter and drill down from high-level metrics to individual performance. My monthly board presentations are now backed by real-time intelligence instead of static spreadsheets. It has become indispensable for data-driven decisions across our Macedonia operations.',
    author: 'Jordan Ignatovski',
    role: 'Managing Director for Macedonia',
    company: 'Bosnalijek',
  },
  {
    quote:
      "I used to spend my Monday mornings building reports in Excel, trying to make sense of scattered data. Now, I spend that time strategizing because PharmaVision's analytics do the heavy lifting for me. The visual dashboards instantly highlight what's working and what's not—from product coverage gaps to underutilized high-potential doctors. The cohort analysis has been particularly valuable for understanding the long-term impact of our sales strategies. My team's productivity has soared because we are focused on high-value activities backed by solid data, not guesswork.",
    author: 'Goran Mirkovski',
    role: 'Sales Manager',
    company: 'PharmaS',
  },
  {
    quote:
      'PharmaVision eliminated the guesswork from management. I have complete transparency into team activities, account coverage, target realization, and resource allocation—all in one powerful system.',
    author: 'Panche Jankovski',
    role: 'Manager',
    company: 'Abela',
  },
  {
    quote:
      "The comparative territory analytics help me identify best practices in high-performing regions and replicate that success across entire area. It's like having a consultant working 24/7 to optimize my operations.",
    author: 'Tose Dermendziev',
    role: 'Area Manager',
    company: 'Abela',
  },
  {
    quote:
      "The drill-down capabilities are incredible—from high-level account health and target achievement down to individual product performance and visit history. I'm always prepared, always informed, and always one step ahead.",
    author: 'Daniel Cvetanoski',
    role: 'Key Account Manager',
    company: 'Abela',
  },
];
